import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { BACKEND_URL } from '../../../utils/config';

const ambassadorApi = createApi({
  reducerPath: 'ambassadorApi',
  baseQuery: fetchBaseQuery({ baseUrl: BACKEND_URL }),
  endpoints: (builder) => ({
    getAmbassadorCollection: builder.query({
      query: ({ personaId, token }) => `/ambassadors/${personaId}/collections/${token}`
    }),
    getAmbassadorProfile: builder.query({
      query: (personaId) => `/ambassadors/${personaId}/profile`
    }),
    getAmbassadors: builder.query({
      query: () => '/ambassadors/featured',
      transformResponse: (response) => {
        // Shuffle the array for randomized display
        const shuffled = [...response];
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
      }
    })
  })
});

export const { useGetAmbassadorsQuery, useGetAmbassadorProfileQuery, useLazyGetAmbassadorCollectionQuery } = ambassadorApi;
export default ambassadorApi;
